export default __webpack_public_path__ + "static/media/head03_en_pc@2x.c294c94c.png";